import React from "react";
import { StandardButton } from "../common/GlobalElements/StandardButton";

const AppealButton = ({ appeal_button, row_id, onClick }) => {
  switch (appeal_button) {
    case "appeal":
      return (
        <>
          <StandardButton
            variant="danger"
            onClick={() => onClick(row_id, "view_appeal")}
            title="Appeal"
          >
            <i className="fa fa-star"></i> Appeal
          </StandardButton>
        </>
      );
      break;
    case "appeal_view":
      return (
        <>
          <StandardButton
            variant="warning"
            onClick={() => onClick(row_id, "view_appeal")}
            title="View Appeal"
          >
            <i className="fa fa-star"></i> View Appeal
          </StandardButton>
        </>
      );
      break;
    case "appeal_submit":
      return (
        <>
          <StandardButton
            variant="disabled"
            onClick={onClick}
            title="Appeal Submitted"
            disabled
          >
            <i className="fa fa-star"></i> Appeal Submitted
          </StandardButton>
        </>
      );
      break;
    default:
      return <></>;
      break;
  }
}
export default AppealButton;
